export enum AssignmentStatuses {
  Active = 1,
  Returned,
  Purchased,
  Paused,
}
